const checkIfValueIsFalsy = (
  value?: string | number | boolean | null,
): boolean => {
  return value === null || value === undefined || value === '';
};

export const buildQueryParams = (params: any): string => {
  const keys = Object.keys(params || {});
  if (!keys.length) return '';

  const newObj = keys
    .filter((key) => !checkIfValueIsFalsy(params[key]))
    ?.reduce((acc: any, key) => {
      acc[key] = params[key];
      return acc;
    }, {});

  return new URLSearchParams(newObj).toString();
};

export const someFieldAreDefined = (values: Record<string, any>): boolean => {
  const isValueDefined = (value: any, seen = new Set()): boolean => {
    if (checkIfValueIsFalsy(value)) {
      return false;
    }
    if (typeof value !== 'object' || value === null) {
      return true;
    }
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);

    if (Array.isArray(value)) {
      return value.some((item) => isValueDefined(item, seen));
    }
    return Object.values(value).some((item) => isValueDefined(item, seen));
  };

  return Object.values(values).some((item) => isValueDefined(item));
};

// Utility function for query params
export const formatQueryParams = (params: Record<string, any>): string => {
  return Object.entries(params)
    .filter(
      ([_, value]) => value !== undefined && value !== null && value !== '',
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');
};
